import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { SemanticRuleItemEntity } from './semantic-rule-item.entity';

export interface ISemanticRuleListExtra
	extends IListColumnConfig<SemanticRuleItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface ISemanticRuleListEntity extends IListAttrs<SemanticRuleItemEntity> {
	availableColumns: Map<string, ISemanticRuleListExtra>;
}

const entityDefaults: ISemanticRuleListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class SemanticRuleListEntity
	implements
		ISemanticRuleListEntity,
		IListOperations<SemanticRuleListEntity, SemanticRuleItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<ISemanticRuleListExtra>
	): SemanticRuleListEntity {
		const inst = new SemanticRuleListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ISemanticRuleListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SemanticRuleItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, SemanticRuleItemEntity>
	): SemanticRuleListEntity {
		return produce(this, (draft: SemanticRuleListEntity) => {
			draft.elements = elems;
		});
	}
}
